"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ftime = void 0;
var fdatetime_1 = require("./fdatetime");
/**
 * formatuje czas do formatu HH:mm:ss
 * @param dt data typu Date
 */
function ftime(dt) {
    return fdatetime_1.formatDateFunction['HH:mm:ss'](dt);
    // return padNumber(dt.getHours()) + ':' + padNumber(dt.getMinutes()) + ':' + padNumber(dt.getSeconds());
}
exports.ftime = ftime;
exports.default = ftime;
//# sourceMappingURL=ftime.js.map